import Paper from "components/general/PaperComponent";
import { RoleCardProps } from "./types";
import styles from "./styles.module.scss";
import AvatarGroup from "components/general/AvatarGroup";
import COLORS from "constants/Colors";

export default function RoleCard({
  data,
  isSelected = false,
  onClick = () => { },
  containerStyle,
  membersCount = 0,
}: RoleCardProps) {
  const badgeText = data?.is_default
    ? "Default"
    : data.is_superuser
      ? "Super User"
      : "";
  return (
    <div className={`${styles.container} ${containerStyle}`} onClick={onClick}>
      <Paper borderColor={isSelected ? COLORS.primary : "#D9D9D9"}>
        <div className={`${styles.wrapper}`}>
          <div className={styles.leftSection}>
            <h3 className={styles.title}>
              {data.name}{" "}
              {data?.is_default || data.is_superuser ? (
                <span className={styles.defaultBadge}>({badgeText})</span>
              ) : null}
            </h3>
            {/* {data.description && <p>{data.description}</p>} */}
          </div>

          <div className={styles.rightSection}>
            <AvatarGroup images={data.avatars} />
            <span className={styles.membersCount}>
              {membersCount || data.staff_ids?.length} members
            </span>
          </div>
        </div>
      </Paper>
    </div>
  );
}
